"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
exports.init = () => ({
    largestIDs: {},
    map: {},
    roots: [],
});
__exportStar(require("./merge"), exports);
__exportStar(require("./deltas"), exports);
__exportStar(require("./apply"), exports);
__exportStar(require("./loc"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./types"), exports);
